import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type ProjectApiResponse = ResponseType<null>;
export type ProjectJobTitleType = {
    assingprojectId:string|undefined
    projectJobTitle:string|undefined
}

function useProjectMemberJobTitleMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<ProjectApiResponse>["response"],
    AxiosResponseAndError<ProjectApiResponse>["error"],
    ProjectJobTitleType
  >({
    mutationFn: (data) =>
      ApiRequest.put<ProjectApiResponse>(`${requestURLs.project}/projectAssgined/job-title-update/${data.assingprojectId}`, {projectJobTitle:data.projectJobTitle}),
  });

  return mutation;
}
export default useProjectMemberJobTitleMutation;